const IconInfo = function () {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className="icon icon-info"><path fill="#000" fillRule="evenodd" d="M9 15h2V9H9v6Zm1-15C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8ZM9 7h2V5H9v2Z"/></svg>
	);
}

export default IconInfo;